<template>
  <g fill-rule="evenodd" fill="none">
    <path d="M.313.312h19.375v19.375H.313V.312z" />
    <path
      d="M16.272 8.323L6.066 18.528l-5.753 1.16 1.16-5.755L11.679 3.73l4.594 4.594zm1.14-1.141l2.275-2.276L15.093.312 12.82 2.586l4.593 4.596z"
      fill-rule="nonzero"
      :fill="color"
    />
  </g>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    }
  }
};
</script>
